import { BusinessAdminNote } from './business-admin-notes.model';


/**
 * Business admin notes and dates object model.  This is the parent object for business admin notes and the various update dates
 * for a business or flying club.
 */

export class BusinessAdminNotesDates {

  /**
   * The changelog of dates.
   */
  changeLog: Array<BusinessAdminNote>;

  /**
   * The admin notes for this business.
   */
  notes: Array<BusinessAdminNote>;

  /**
   * Parses a business as returned by the API into an instance of the Business class
   */
  static parse(data: any): BusinessAdminNotesDates {
    return Object.assign(new BusinessAdminNotesDates(), {
      changeLog: (data.changeLog || []).map(d => BusinessAdminNote.parse(d)),
      notes: (data.notes || []).map(d => BusinessAdminNote.parse(d))
    });
  }
}
